import React from 'react';
import AlreadyRated from 'assets/images/icon/already-rated.svg';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { getLanguage } from '../../../../utils/params';

const AlreadyRatedComponent = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const location = useLocation();
    const language = getLanguage(location);
    // const ratingApartment = JSON.parse(localStorage.getItem('ratingApartment'));
    // useEffect(() => {
    //     console.log(ratingApartment);
    //     // return function cleanup() {
    //     //     localStorage.removeItem('ratingApartment');
    //     // };
    //     // eslint-disable-next-line
    // }, [ratingApartment]);

    const redirectHome = () => {
        history.push(`/${language}/`);
    };

    return (
        <>
            <div className="row">
                <div className="col-12 mt-4 d-flex justify-content-center">
                    <img className="mt-5" src={AlreadyRated} alt="already-rated" />
                </div>
                <div className="col-12 mb-4">
                    <h3 className="rating-title mt-4 mb-3 text-center font-weight-bold">{t('detailApartment.already_rated')}</h3>
                    <div className="text-center">{t('detailApartment.title_review_success')}</div>
                    <div className="d-flex justify-content-center mt-4 mb-3">
                        <button type="button" onClick={redirectHome} className="button-red mb-5 btn-go-gome">{t('detailApartment.go_home')}</button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AlreadyRatedComponent;
